'use client';

import { useEffect, useState } from 'react';
import { getSessionSummaryAction, type SessionSummary } from '@/actions/session.actions';

export function useSessionSummary(): { summary: SessionSummary | null; loading: boolean } {
  const [summary, setSummary] = useState<SessionSummary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    getSessionSummaryAction()
      .then((result) => {
        if (!cancelled) {
          setSummary(result);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { summary, loading };
}
